import { useCallback, useMemo } from 'react';
import {
  AnalyticsEventData,
  AnalyticsEventImportance,
  AnalyticsEventName,
  logEvent as logAnalyticsEvent,
} from '@cbhq/client-analytics';

import { useLocale } from '../../hooks/useLocale';
import { PACKAGE_VERSION } from '../../version';
import { useClientProps } from '../providers/ClientPropsProvider';

export function useAnalytics() {
  const { projectId, action } = useClientProps();
  const locale = useLocale();

  const logEvent = useCallback(
    (
      eventName: AnalyticsEventName,
      eventData: AnalyticsEventData,
      eventImportance?: AnalyticsEventImportance,
    ) => {
      logAnalyticsEvent(
        eventName,
        {
          ...eventData,
          package_name: '@cbhq/profile-dropdown',
          package_version: PACKAGE_VERSION as string,
          projectId,
          clientAction: action,
          locale,
        },
        eventImportance,
      );
    },
    [projectId, action, locale],
  );

  return useMemo(
    () => ({
      logEvent,
    }),
    [logEvent],
  );
}
